import React from 'react';
import BaseIcon from './BaseIcon';

const pathData1 = 'M16 14.4009H0V16H16V14.4009Z';
const pathData2 = [
  'M2.46378 10.0035L0.749596 8.11418L1.56923 7.2171L3.28341 9.10561L5.00778 7.2171L5.82741 ',
  '8.11418L4.09141 10.0035L5.82741 11.8928L5.00778 12.7899L3.28341 10.8886L1.54741 ',
  '12.7899L0.727051 11.8912L2.46378 10.0035Z',
].join('');
const pathData3 = [
  'M11.8635 13.5862C11.759 13.5838 11.6567 13.5524 11.5661 13.495C10.4272 12.817 10.7624 10.2697 ',
  '11.7392 5.01994C11.905 4.13085 12.0934 3.11784 12.2112 2.33189C10.5029 5.89724 8.97735 9.56486 ',
  '7.64172 13.3175L6.55518 12.7219C11.0766 0.79438 12.0272 -0.326574 12.9923 0.062002C13.8228 ',
  '0.39541 13.5915 1.63949 12.9043 5.33336C12.5111 7.25101 12.2228 9.19284 12.041 11.1484C12.4388 ',
  '10.3944 13.0082 9.76729 13.6934 9.32865C14.1531 9.05236 14.6591 8.88154 15.1806 8.82654L15.289 ',
  '10.2553C14.9177 10.2938 14.5575 10.4149 14.2301 10.6111C13.5222 11.1225 12.9728 11.8588 ',
  '12.6548 12.7219C12.5469 13.1424 12.2467 13.4702 11.8635 13.5862Z',
].join('');

const SigningSignIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d={pathData1} />
      <path d={pathData2} />
      <path d={pathData3} />
    </g>
  </BaseIcon>
);

export default SigningSignIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/SigningSignIcon.jsx